// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6feadee9] .vxe-toolbar {\n  height: 10px;\n}\n.contract_img[data-v-6feadee9] {\n  width: 100%;\n}\n.contract_img img[data-v-6feadee9] {\n  width: 100px;\n  height: 120px;\n  -o-object-fit: cover;\n     object-fit: cover;\n  margin-right: 32px;\n}\n.contract_img img[data-v-6feadee9]:first-child {\n  margin-left: 78px;\n}\n", ""]);
// Exports
module.exports = exports;
